export default __webpack_public_path__ + "static/media/RVReport.1777d4c9.png";